// src/store/auth/forgetpwd/saga.js

import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import { toast } from "react-toastify";

import {
  FORGET_PASSWORD,
  RESET_PASSWORD,
} from "./actionTypes";

import {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  userResetPasswordSuccess,
  userResetPasswordError,
} from "./actions";

import {
  forgetPasswordApi,
  resetPasswordApi}
  from "../../../apiServices/service"


// ================= FORGET PASSWORD =================
function* forgetUser({ payload: { user } }) {
  try {
    const response = yield call(forgetPasswordApi, {
      email: user.email,
    });

    if (response) {
      toast.success(response?.data?.message || "Temporary password sent");

      yield put(
        userForgetPasswordSuccess(
          response?.data?.message || "Temporary password sent"
        )
      );
    }
  } catch (error) {
    toast.error(error?.error || "Failed to send email");

    yield put(
      userForgetPasswordError(
        error?.error || "Failed to send email"
      )
    );
  }
}


// ================= RESET PASSWORD =================
function* resetUser({ payload: { data, history } }) {
  try {
    const response = yield call(resetPasswordApi, data);

    if (response) {
      const message = response?.data?.message || "Password updated successfully";

      toast.success(message);

      yield put(userResetPasswordSuccess(message));

      // ✅ Redirect AFTER dispatch
      if (history) {
        history("/login"); // using navigate
      } else {
        window.location.href = "/login";
      }
    }
  } catch (error) {
    console.error("Reset password failed:", error);

    yield put(
      userResetPasswordError(
        error?.error || "Failed to reset password"
      )
    );
  }
}

// ================= WATCHERS =================
export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser);
}

export function* watchUserPasswordReset() {
  yield takeEvery(RESET_PASSWORD, resetUser);
}


// ================= ROOT =================
function* forgetPasswordSaga() {
  yield all([
    fork(watchUserPasswordForget),
    fork(watchUserPasswordReset),
  ]);
}

export default forgetPasswordSaga;